import { render, staticRenderFns } from "./BillInvalidManage.vue?vue&type=template&id=0fc0a7a2&scoped=true&"
import script from "./BillInvalidManage.js?vue&type=script&lang=js&"
export * from "./BillInvalidManage.js?vue&type=script&lang=js&"
import style0 from "@/assets/style/common.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0a7a2",
  null
  
)

export default component.exports